import React, { Component } from 'react';
import { GraingerAccountContext } from '../../Context/Context';

import PropTypes from 'prop-types';

import './Link.scss';

class Link extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  render() {
    const { page, className, children } = this.props;
    const { setPage } = this.context;

    return (
      <span
        className={'link' + (className ? ` ${className}` : '')}
        onClick={() => setPage(page)}
      >
        {children}
      </span>
    );
  }
}

Link.propTypes = {
  page: PropTypes.string.isRequired,
  className: PropTypes.string
};

Link.defaultProps = {
  className: null
}

Link.contextType = GraingerAccountContext;
export default Link;